export interface VoucherBatchCount {
  label: string;
  value: number;
  hint: string;
}

interface VoucherBatchResultViewProps {
  counts: VoucherBatchCount[];
  errors: string[];
}

// The backend reports batch outcomes as counts plus a flat error list; it never returns the rows it wrote.
export function VoucherBatchResultView({ counts, errors }: VoucherBatchResultViewProps) {
  return (
    <div className="tw-space-y-3">
      <div className="tw-grid tw-grid-cols-4 tw-gap-2.5">
        {counts.map((count) => (
          <div key={count.label} className="tw-rounded-lg tw-border tw-border-border tw-bg-card tw-px-3 tw-py-2.5">
            <div className="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-muted-foreground">
              {count.label}
            </div>
            <div className="tw-mt-1 tw-text-xl tw-font-bold tw-leading-none">{count.value}</div>
            <div className="tw-mt-1 tw-text-[11px] tw-text-muted-foreground">{count.hint}</div>
          </div>
        ))}
      </div>

      {errors.length > 0 && (
        <div className="tw-rounded-lg tw-border tw-border-red-200 tw-bg-red-50 tw-px-3.5 tw-py-2.5">
          <div className="tw-text-xs tw-font-semibold tw-text-red-700">{errors.length} failed</div>
          <ul className="tw-mt-1.5 tw-max-h-[180px] tw-space-y-1 tw-overflow-y-auto tw-text-xs tw-text-red-700">
            {errors.map((error) => (
              <li key={error} className="tw-font-mono tw-leading-snug">
                {error}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
